<section class="popup-page" [attr.aria-busy]="isSubmitting">
  <header>
    <button type="button" class="icon-button" (click)="back()" [disabled]="isSubmitting" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8592;</button>
    <h2>{{ 'PROFILE_POPUP_MOBILE_ACCESS' | translate }}</h2>
    <button type="button" class="icon-button" (click)="close()" [disabled]="isSubmitting" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <div class="card">
    <div class="status-icon" aria-hidden="true"><mat-icon>smartphone</mat-icon></div>
    <h3>{{ profileDetails?.firstName }} {{ profileDetails?.middleName }} {{ profileDetails?.lastName }}</h3>
    <span class="status" [class.enabled]="enabled" role="status">{{ statusKey | translate }}</span>
    <p>{{ 'PROFILE_POPUP_MOBILE_DESCRIPTION' | translate }}</p>
    <dl>
      <dt>{{ 'EMAIL' | translate }}</dt><dd>{{ profileDetails?.email }}</dd>
      <dt>{{ 'PHONE_NUMBER' | translate }}</dt><dd>{{ profileDetails?.phoneNumber || ('PROFILE_POPUP_NOT_SET' | translate) }}</dd>
    </dl>
    <p *ngIf="!enabled && !canInvite" class="hint">{{ 'PROFILE_POPUP_MOBILE_INVITE_UNAVAILABLE' | translate }}</p>
    <p *ngIf="invitationSent" class="success" role="status">{{ 'PROFILE_POPUP_MOBILE_INVITE_SUCCESS' | translate }}</p>
    <p *ngIf="errorKey" class="error" role="alert">{{ errorKey | translate }}</p>
    <p *ngIf="isSubmitting" role="status">{{ 'PROFILE_POPUP_SENDING_INVITE' | translate }}</p>
    <button *ngIf="!enabled" type="button" class="primary-button" [disabled]="!canInvite || isSubmitting || invitationSent" (click)="sendInvite()">
      {{ (invitePending ? 'RESEND_INVITATION' : 'PROFILE_POPUP_SEND_INVITATION') | translate }}
    </button>
  </div>
</section>